import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/modules/SanitizedContent.tsx");
